import styled from 'styled-components/macro';
import { css } from 'styled-components';

import {
  applyStyleModifiers,
  styleModifierPropTypes,
} from 'styled-components-modifiers';
import { lighten } from 'polished';

const WRAP_MODIFIERS = {
  active: ({ theme }) => css`
    //background-color: ${theme.palette.border};
    background-color: rgba(242,242,247,255);
    cursor: default;

    &:hover {
      //background-color: ${theme.palette.border};
      background-color: rgba(242,242,247,255);
    }
  `,
};
const MessageWrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  background-color: white;
  border-bottom: 1px solid rgba(227,227,230,255);

  &:hover {
    //background-color: ${({ theme }) => lighten(0.1, theme.palette.border)};
    background-color: rgba(242,242,247,255);
  }

  ${applyStyleModifiers(WRAP_MODIFIERS)}
`;
MessageWrap.proptypes = {
  modifiers: styleModifierPropTypes(WRAP_MODIFIERS),
};

const ActionMenuWrap = styled.div.attrs(() => ({
  className: 'action-menu',
}))`
  position: absolute;
  top: 24px;
  right: 36px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${(props) => (props.alwaysVisible ? 1 : 0)};
  transition: opacity 0.2s ease;
  cursor: pointer;
  z-index: 2;

  span {
    font-size: 18px;
    font-weight: bold;
  }
`;

const ContextMenu = styled.div`
  position: absolute;
  top: 32px;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
  z-index: 1000;
  width: 150px;

  div {
    padding: 10px 12px;
    font-size: 14px;
    cursor: pointer;

    &:hover {
      background-color: #f5f5f5;
    }
  }
`;

const ChannelMessageWrap = styled.div`
  position: relative;
  display: flex;
  padding: 1rem;
  background-color: white;
  border-bottom: 1px solid rgba(227,227,230,255);
  width: 373px;
  height: 72px;

  &:hover {
    background-color: rgba(242,242,247,255);
  }

  &:hover .action-menu:not(.menu-open) {
    opacity: 1;
  }

  ${applyStyleModifiers(WRAP_MODIFIERS)}
  //border: 1px solid red;
`;
ChannelMessageWrap.proptypes = {
  modifiers: styleModifierPropTypes(WRAP_MODIFIERS),
};


const Info = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;


export {
  MessageWrap,
  ChannelMessageWrap,
  Info,
  ContextMenu,
  ActionMenuWrap
};
